import React from "react";
import ReactModal from "react-modal";
import * as R from "ramda";
import AccessCardFormFields from "./AccessCardFormFields";
import { connect } from "react-redux";
import { updateOne } from "actions/accessCard";
import Icon from "components/Icon";
import { fetchAll } from "actions/user";

const mapStateToProps = state => ({
  isUpdating: state.location.isUpdating,
  users: state.user.byId,
  isFetching: state.user.isFetching
});

const mapDispatchToProps = { updateOne, fetchAll };

class UpdateAccessCardModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      accessCard: {
        ...props.accessCard
      }
    };
    if (props.accessCard.access_levels.length === 0) {
      this.state.accessCard.access_levels = [""];
    } else {
      this.state.accessCard.access_levels = props.accessCard.access_levels.map(
        ({ id }) => id
      );
    }
  }

  handleSubmit = event => {
    event.preventDefault();
    const { updateOne } = this.props;
    const { accessCard } = this.state;

    const data = {
      ...accessCard,
      access_levels: accessCard.access_levels.filter(r => !!r)
    };

    updateOne(accessCard.id, data).then(this.handleCloseModal);
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  handleOpenModal = () => {
    this.props.fetchAll();
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id).then(this.handleCloseModal);
  };

  render() {
    const { title, users } = this.props;
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.handleOpenModal}
        >
          <Icon icon="pencil-alt" />
        </button>
        <ReactModal
          onRequestClose={this.handleCloseModal}
          className="Modal"
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          contentLabel="Delete Confirmation"
        >
          <form onSubmit={this.handleSubmit}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                </div>
                <div className="modal-body">
                  <AccessCardFormFields
                    accessCard={this.state.accessCard}
                    onChange={this.handleChange}
                    users={users}
                    user={users[this.state.accessCard.user_id]}
                  />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" type="submit">
                    Rediger
                  </button>
                  <button className="btn" onClick={this.handleCloseModal}>
                    Avbryt
                  </button>
                </div>
              </div>
            </div>
          </form>
        </ReactModal>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  UpdateAccessCardModal
);



// WEBPACK FOOTER //
// ./src/components/UpdateAccessCardModal.js